import $ from 'jquery'
import 'slick-carousel'
import 'sticky-kit/dist/sticky-kit'

export const rendertabsImages = (
  container = document.querySelector('.tabs-widget-images'),
) => {
  const tabs = $(container).find('.menu-slider')
  const navListItem = tabs.find('.item')
  const line = $(container).find('.line')

  if (navListItem.length > 1) {
    const tabsFixed = $(container).find('.tabs-nav-slider')
    const contentSlider = $(container).find('.tabs-content-slider')
    const activeWidth = tabs.find('.active-nav').width()
    const firstChild = tabs.find('.item:first-child')
    const defaultMarginLeft = parseInt(tabs.find('.item:first-child').next().css('marginLeft').replace(/\D/g, ''), 0)
    const defaultPaddingLeft = parseInt(tabs.css('padding-left').replace(/\D/g, ''), 0)
    const animSpeed = 250

    function resizeHandler() {
      setTimeout(() => {
        const adminMenuHeight = parseInt($('body').css('padding-top'), 10)
        const headerHeight = $('.site-header').outerHeight() - $('.site-header__pre-header').outerHeight() + 4 + adminMenuHeight

        tabsFixed.trigger('sticky_kit:detach')
        tabsFixed.stick_in_parent({
          offset_top: headerHeight,
        })
      })
    }

    resizeHandler()
    $('.cookie-banner').find('.btn-close , .btn-holder a').on('click', () => {
      resizeHandler()
    })
    $(window).on('resize', resizeHandler)

    $(window).on('scroll', () => {
      setTimeout(() => {
        $('.tabs-nav-slider.is_stuck').css('top', $('.site-header').outerHeight())
      })
    })

    tabs.slick({
      rows: 0,
      arrows: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      touchThreshold: 15,
      variableWidth: true,
      asNavFor: contentSlider,
      focusOnSelect: true,
      accessibility: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            focusOnSelect: false,
            slidesToShow: 3,
          },
        },
      ],
    })
    contentSlider.slick({
      rows: 0,
      arrows: false,
      adaptiveHeight: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      touchThreshold: 15,
      variableWidth: false,
      asNavFor: tabs,
      swipe: false,
      touchMove: false,
      draggable: false,
      fade: true,
      accessibility: false,
      lazyLoad: 'ondemand',
    })
    line.width(activeWidth)
    line.css('marginLeft', defaultPaddingLeft)
    tabs.on('swipe', () => {
      const currentel = tabs.find('.slick-current')
      const activeNav = tabs.find('.active-nav')
      const currentWidth = activeNav.width()
      const currentOffset = activeNav.position().left
      const currentIndex = activeNav.index()
      const parentsOffset = tabs.find('.slick-track').position().left
      let initWidth = activeWidth
      let marginLeftToSet

      activeNav.removeClass('active-nav')
      currentel.addClass('active-nav')
      line.removeAttr('data-active')

      if (currentel.is(activeNav)) {
        return 0
      } if (currentel.index() > currentIndex) {
        if (activeNav.is(firstChild)) {
          initWidth = defaultMarginLeft + currentel.width() + currentel.position().left - defaultPaddingLeft
        } else {
          initWidth = currentel.position().left + currentel.width() - currentOffset
        }
        marginLeftToSet = currentel.position().left + defaultMarginLeft + parentsOffset
        line.width(initWidth)
        return setTimeout(() => {
          line.css('marginLeft', marginLeftToSet)
          line.width(currentel.width())
          line.attr('data-active', currentel.index())
        }, animSpeed)
      }
      if (currentel.is(firstChild)) {
        initWidth = currentOffset - defaultPaddingLeft + defaultMarginLeft + currentWidth
        marginLeftToSet = currentel.position().left
      } else {
        initWidth = currentWidth + currentOffset - currentel.position().left
        marginLeftToSet = currentel.position().left + defaultMarginLeft + parentsOffset
      }
      line.css('marginLeft', marginLeftToSet)
      line.width(initWidth)
      return setTimeout(() => {
        line.width(currentel.width())
        line.attr('data-active', currentel.index())
      }, animSpeed)
    })
    navListItem.on('click', function () {
      const currentel = $(this)
      const activeNav = tabs.find('.active-nav')
      const currentWidth = activeNav.width()
      const currentOffset = activeNav.position().left
      const currentIndex = activeNav.index()
      const parentsOffset = tabs.find('.slick-track').position().left
      let initWidth = activeWidth
      let marginLeftToSet

      activeNav.removeClass('active-nav')
      currentel.addClass('active-nav')
      line.removeAttr('data-active')

      if (currentel.is(activeNav)) {
        return 0
      } if (currentel.index() > currentIndex) {
        if (activeNav.is(firstChild)) {
          initWidth = defaultMarginLeft + currentel.width() + currentel.position().left - defaultPaddingLeft
        } else {
          initWidth = currentel.position().left + currentel.width() - currentOffset
        }
        marginLeftToSet = currentel.position().left + defaultMarginLeft + parentsOffset
        line.width(initWidth)
        return setTimeout(() => {
          line.css('marginLeft', marginLeftToSet)
          line.width(currentel.width())
          line.attr('data-active', currentel.index())
        }, animSpeed)
      }
      if (currentel.is(firstChild)) {
        initWidth = currentOffset - defaultPaddingLeft + defaultMarginLeft + currentWidth
        marginLeftToSet = currentel.position().left
      } else {
        initWidth = currentWidth + currentOffset - currentel.position().left
        marginLeftToSet = currentel.position().left + defaultMarginLeft + parentsOffset
      }
      line.css('marginLeft', marginLeftToSet)
      line.width(initWidth)
      return setTimeout(() => {
        line.width(currentel.width())
        line.attr('data-active', currentel.index())
      }, animSpeed)
    })
  } else {
    navListItem.addClass('active-nav')
    line.css('width', '100%')
  }
}
